module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"btnCreateNewFund":"Create new fund","btnEdit":"View my reports","textPeriod":"Investment period:","textVolume":"Volume:","btnFundSetup":"Setup Fund"},"de":{"btnCreateNewFund":"Neuen Fonds erstellen","btnEdit":"Berichte ansehen","textPeriod":"Investitionszeitraum:","textVolume":"Volumen:","btnFundSetup":"Fonds anlegen"}}')
  delete Component.options._Ctor
}
